import * as React from 'react';
import { InputNumber, InputNumberProps } from 'antd';
import { CustomInputLabel, CustomModifiedMarker } from '..';
import { Utils } from '../../misc';
import './CustomInputNumber.less';

export interface CustomInputNumberProps extends Omit<InputNumberProps, 'placeholder'> {
    label: string;
    labelTooltip?: string;
    required?: boolean;
    topRightNode?: React.ReactNode;
    containerStyle?: React.CSSProperties;
    hideStepperButton?: boolean;
    hasError?: boolean;
    showModifiedMarker?: boolean;
    getContainerRef?: (containerRef: React.RefObject<HTMLDivElement>) => void;
}

const CustomInputNumber: React.FC<CustomInputNumberProps> = (props: CustomInputNumberProps) => {
    const {
        label,
        labelTooltip,
        required,
        topRightNode,
        containerStyle,
        hideStepperButton,
        hasError,
        showModifiedMarker,
        getContainerRef,
        ...inputNumberProps
    } = props;

    const containerRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        if (getContainerRef) {
            getContainerRef(containerRef);
        }
    }, [getContainerRef]);

    const getClassName = () => {
        let className = 'custom-input-number';

        if (Utils.hasValue(inputNumberProps.value)) {
            className += ' not-empty';
        }

        if (hideStepperButton) {
            className += ' hide-stepper-button';
        }

        return className;
    };

    const getContainerClassName = () => {
        let className = 'custom-input-number-container';

        if (hasError) {
            className += ' has-error';
        }

        return className;
    };

    return (
        <div ref={containerRef} className={getContainerClassName()} style={containerStyle}>
            {!!topRightNode && <div className="top-right-node-container">{topRightNode}</div>}

            <InputNumber className={getClassName()} {...inputNumberProps} />

            <CustomInputLabel label={label} labelTooltip={labelTooltip} required={required} />

            {showModifiedMarker && <CustomModifiedMarker />}
        </div>
    );
};

export default CustomInputNumber;
